import '../../constants/const.css';
import { COLOR_CODE, LINE_SEQ } from '../../constants/const';
import React, { useEffect, useRef } from 'react';
import { Chart, ChartOptions, registerables, ChartDataset } from 'chart.js';

// 必要なコンポーネントを登録
Chart.register(...registerables);

interface pitProps {
  dayCount: number;
  autoDraft: number[][];
  lineTitles: string[];
  isSelect: boolean[];
  unit: string;
  exist?: boolean[];
}

const FONT_SIZE_14 = 14;
const BAR_THICKNESS: number = 10;
const GRID_LINE_WIDTH: number = 0.2;

const COLOR_ARRAY: string[] = [COLOR_CODE.PLAN, COLOR_CODE.RESULT, COLOR_CODE.DRAFT1, COLOR_CODE.DRAFT2, COLOR_CODE.DRAFT3, COLOR_CODE.DRAFT4, COLOR_CODE.DRAFT5];

const ElectricSumGraph2: React.FC<pitProps> = (pitProps) => {
  const chartRef = useRef<HTMLCanvasElement>(null);
  const chartInstanceRef = useRef<Chart | null>(null);

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext('2d');

      if (ctx) {
        // 既存のチャートインスタンスが存在する場合、破棄する
        if (chartInstanceRef.current) {
          chartInstanceRef.current.destroy();
        }

        const labelStr: string[] = [];
        labelStr.push('合計');

        const tempDatasets: ChartDataset<'bar'>[] = [];
        for (let num = 0; num < pitProps.autoDraft.length; num++) {
          let isSet: boolean = true;
          if (pitProps.exist && (num === LINE_SEQ.PLAN || num === LINE_SEQ.RESULT)) {
            if (!pitProps.exist[num]) {
              isSet = false;
            }
          } else if (pitProps.exist && num >= LINE_SEQ.DRAFT1 && pitProps.exist.length >= LINE_SEQ.DRAFT1) {
            if (!pitProps.exist[LINE_SEQ.DRAFT1]) {
              isSet = false;
            }
          }
          if (isSet) {
            tempDatasets.push({
              label: pitProps.lineTitles[num],
              data: [
                pitProps.autoDraft[num].reduce(function (a, x) {
                  return a + x;
                }),
              ],
              backgroundColor: COLOR_ARRAY[num],
              barThickness: BAR_THICKNESS,
              hidden: !pitProps.isSelect[num],
            });
          }
        }

        const data = { labels: labelStr, datasets: tempDatasets };

        const options: ChartOptions<'bar'> = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
              position: 'top',
            },
          },
          layout: {
            padding: {
              top: FONT_SIZE_14 * 2,
            },
          },
          scales: {
            x: {
              beginAtZero: true,

              ticks: {
                font: {
                  size: FONT_SIZE_14,
                },
              },
              grid: {
                color: 'black',
                drawTicks: false,
                lineWidth: GRID_LINE_WIDTH,
              },
            },
            y: {
              beginAtZero: true,
              min: 0,
              ticks: {
                font: {
                  size: FONT_SIZE_14,
                },
                callback: function (value) {
                  return `${value.toLocaleString()}`;
                },
              },
              grid: {
                color: 'black',
                drawTicks: false,
                lineWidth: GRID_LINE_WIDTH,
              },
            },
          },
        };

        // 新しいチャートを作成して、参照を保持する
        chartInstanceRef.current = new Chart(ctx, {
          type: 'bar',
          data: data,
          options: options,
          plugins: [
            {
              id: 'unitDraw',
              afterDraw: (chart) => {
                const ctx = chart.ctx;
                ctx.save();
                ctx.font = `bold ${FONT_SIZE_14}px`;
                ctx.fillStyle = chart?.options?.scales?.y?.ticks?.color?.toString() || '#666';

                // 左Y軸の単位
                if (chart.scales.y) {
                  ctx.textAlign = 'left';
                  ctx.textBaseline = 'bottom';
                  ctx.fillText(`単位：[${pitProps.unit}]`, chart.scales.y.left, chart.chartArea.top - FONT_SIZE_14);
                }
                ctx.restore();
              },
            },
          ],
        });
      }
    }

    // クリーンアップ時にチャートを破棄する
    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [pitProps.autoDraft, pitProps.dayCount, pitProps.lineTitles, pitProps.isSelect]);

  return <canvas ref={chartRef} style={{ maxHeight: '100%', maxWidth: '200px' }} />;
};

export default ElectricSumGraph2;
